module.exports = __webpack_public_path__ + "img/briefcase-icon.a644b66d.svg";